import React, { useState, useEffect } from 'react';
import './FinanceAddCredit.css';
import { format } from 'date-fns';

const FinanceAddCredit = () => {
  const [form, setForm] = useState({
    partner_name: '',
    transaction_type: 'Credited',
    amount: '',
    transaction_mode: 'UPI',
    date_of_payment: '',
    description: '',
  });
  const [partners, setPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState('');
  const [history, setHistory] = useState([]);
  const [totals, setTotals] = useState({ total_credited: 0, total_debited: 0 });

  const fetchHistory = async (partner = '') => {
    try {
      const url = partner
  ? `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5012'}/partner-history?partner=${partner}`
  : `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5012'}/partner-history`;

const response = await fetch(url);
const data = await response.json();

      setHistory(data.history || []);
      setPartners(data.partners || []);
      setTotals(data.totals || { total_credited: 0, total_debited: 0 });
    } catch (error) {
      console.error('Error fetching history:', error);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.partner_name || !form.amount || !form.date_of_payment) {
      alert('Please fill all required fields.');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5012'}/add-partner-transaction`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(form),
});


      const data = await response.json();
      if (response.ok) {
        alert('Transaction added successfully');
        setForm({
          partner_name: '',
          transaction_type: 'Credited',
          amount: '',
          transaction_mode: 'UPI',
          date_of_payment: '',
          description: '',
        });
        setHistory(data.history || []);
        setTotals(data.totals || { total_credited: 0, total_debited: 0 });
      } else {
        alert(data.error || 'Error adding transaction');
      }
    } catch (error) {
      console.error('Error submitting transaction:', error);
    }
  };

  return (
    <div className="finance-container">
      <h2>Partner Transactions</h2>

     <div className="totals">
  <h3>
    Total Credited: ₹
    {Number(totals.total_credited || 0).toFixed(2)}
  </h3>
  <h3>
    Total Debited: ₹
    {Number(totals.total_debited || 0).toFixed(2)}
  </h3>
</div>

      <div className="add-credit-form">
        <select
          name="partner_name"
          value={form.partner_name}
          onChange={handleChange}
          required
        >
          <option value="">Select Partner</option>
          <option value="Rajkumar Bande">Rajkumar Bande</option>
          <option value="Siddamma Biradar">Siddamma Biradar</option>
          <option value="Akash Bande">Akash Bande</option>
          <option value="Sharanu Alange">Sharanu Alange</option>
        </select>
        <select name="transaction_type" value={form.transaction_type} onChange={handleChange}>
          <option value="Credited">Credited</option>
          <option value="Debited">Debited</option>
        </select>
        <input
          type="number"
          name="amount"
          value={form.amount}
          onChange={handleChange}
          placeholder="Amount"
          required
        />
        <select name="transaction_mode" value={form.transaction_mode} onChange={handleChange}>
          <option value="UPI">UPI</option>
          <option value="Cash">Cash</option>
        </select>
        <input
          type="date" 
          name="date_of_payment"
          value={form.date_of_payment}
          onChange={handleChange}
          required
        />
        <textarea
          name="description"
          value={form.description}
          onChange={handleChange}
          placeholder="Description (optional)"
        ></textarea>
        <button onClick={handleSubmit}>Submit</button>
      </div>

      <div className="filter-section">
        <label>Filter by Partner: </label>
        <select value={selectedPartner} onChange={(e) => {
          const partner = e.target.value;
          setSelectedPartner(partner);
          fetchHistory(partner);
        }}>
          <option value="">All</option>
          {partners.map((partner, idx) => (
            <option key={idx} value={partner}>{partner}</option>
          ))}
        </select>
      </div>

      <h3>Transaction History</h3>
<div className="history-table-container">
  {history.length > 0 ? (
    <table className="history-table">
      <thead>
        <tr>
          <th>Partner Name</th>
          <th>Type</th>
          <th>Amount (₹)</th>
          <th>Mode</th>
          <th>Date</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        {history.map((entry) => (
          <tr key={entry.id}>
            <td>{entry.partner_name}</td>
            <td
              className={
                entry.transaction_type === 'Credited'
                  ? 'credited'
                  : 'debited'
              }
            >
              {entry.transaction_type}
            </td>
            <td>{Number(entry.amount).toFixed(2)}</td>
            <td>{entry.transaction_mode}</td>
            <td>
              {entry.date_of_payment
                ? format(new Date(entry.date_of_payment), 'dd-MM-yyyy')
                : 'N/A'}
            </td>
            <td>{entry.description || '-'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p className="no-history">No transactions yet.</p>
  )}
</div>

    </div>
  );
};

export default FinanceAddCredit;
